import { resolve } from "videojs-contrib-dash";

export default class DrmDetector {
  constructor() {
    this._config = [{
      'initDataTypes': ['cenc'],
      'videoCapabilities': [{ 'contentType': 'video/mp4;codecs="avc1.4D401E"' }]
    }];
  }

  config() {
    return this._config;
  }

  static get keySystems() {
    return ['com.microsoft.playready',
      'com.widevine.alpha',
      'com.apple.fairplay',
      'com.apple.fps'];
  }

  async drmCheck(keysystem) {
    try {
      return await navigator.requestMediaKeySystemAccess(keysystem, this.config());
    } catch(e) {
      return Promise.resolve(false);
    }
  }

  async hdcpCheck(mediaKeySystemAccess, hdcpLevel) {
    try {
      const mediaKeys = await this.createMediaKeys(mediaKeySystemAccess);
      const hdcp_status = await this.checkMediaKeys(mediaKeys, hdcpLevel);
      return this.checkHDCPStatus(hdcp_status);
    } catch(e) {
      console.warn(e);
      return Promise.resolve('unsupported');
    }
  }

  createMediaKeys(mediaKeySystemAccess) {
    return mediaKeySystemAccess.createMediaKeys();
  }

  checkMediaKeys(mediaKeys, hdcpLevel) {
    if (!('getStatusForPolicy' in mediaKeys)) {
      return Promise.resolve('unsupported');
    }

    return mediaKeys.getStatusForPolicy(hdcpLevel);
  }

  checkHDCPStatus(hdcp_status) {
    if (hdcp_status !== 'usable') {
      return Promise.resolve('unsupported');
    }
    return Promise.resolve('supported');
  }

  async widevineHdcpCheck() {
    return this.drmCheck('com.widevine.alpha').then((response) => {
      if(response) {
        return this.hdcpCheck(response, { minHdcpVersion: '1.0' });
      } else {
        return Promise.reject();
      }
    });
  }
}
